<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'NonTariffMeasure',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Наименование нетарифной меры',
        canEdit: true,
        apiRoute: 'NsiNonTariffMeasure',
        cardName: 'NonTariffMeasureCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
